import styled from "styled-components";

const ExpandablePanelWrapper = styled.div`
  max-height: ${props => (props.expanded ? "30rem" : "0")};
  opacity: ${props => (props.expanded ? "1" : "0")};
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  overflow: hidden;
  width: 100%;
  margin-top: ${props => (props.expanded ? "1rem" : "0")};
  position: relative;

  &:before {
    content: "";
    border-top: solid 1px
      ${props => props.theme.expandablePanel.before.borderTopColor};
    padding: 0rem 0.5rem;
    box-shadow: ${props => props.theme.expandablePanel.before.boxShadow}
      ${props => props.theme.expandablePanel.before.boxShadowColor};
    width: calc(100% - 1rem);
    display: block;
    position: absolute;
    height: 1px;
    top: 1px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
`;

export { ExpandablePanelWrapper };
